function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1825 7.11111C14.9468 7.11111 14.7207 7.20476 14.554 7.37146C14.3873 7.53816 14.2936 7.76425 14.2936 8V13.3333C14.2936 13.5691 14.2 13.7952 14.0333 13.9619C13.8666 14.1286 13.6405 14.2222 13.4047 14.2222H2.73808C2.50233 14.2222 2.27624 14.1286 2.10954 13.9619C1.94284 13.7952 1.84919 13.5691 1.84919 13.3333V2.66667C1.84919 2.43092 1.94284 2.20483 2.10954 2.03813C2.27624 1.87143 2.50233 1.77778 2.73808 1.77778H8.07141C8.30716 1.77778 8.53325 1.68413 8.69995 1.51743C8.86665 1.35073 8.9603 1.12464 8.9603 0.888889C8.9603 0.653141 8.86665 0.427048 8.69995 0.260349C8.53325 0.0936505 8.30716 0 8.07141 0H2.73808C2.03083 0 1.35256 0.280952 0.85246 0.781049C0.352363 1.28115 0.0714111 1.95942 0.0714111 2.66667V13.3333C0.0714111 14.0406 0.352363 14.7189 0.85246 15.219C1.35256 15.719 2.03083 16 2.73808 16H13.4047C14.112 16 14.7903 15.719 15.2904 15.219C15.7905 14.7189 16.0714 14.0406 16.0714 13.3333V8C16.0714 7.76425 15.9778 7.53816 15.8111 7.37146C15.6444 7.20476 15.4183 7.11111 15.1825 7.11111Z",
  fill: "url(#paint0_linear_1972_20961)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6276 1.77778H13.032L7.44091 7.36C7.3576 7.44263 7.29147 7.54095 7.24634 7.64927C7.20121 7.75758 7.17798 7.87377 7.17798 7.99111C7.17798 8.10846 7.20121 8.22464 7.24634 8.33296C7.29147 8.44128 7.3576 8.53959 7.44091 8.62222C7.52354 8.70554 7.62186 8.77166 7.73018 8.81679C7.83849 8.86192 7.95468 8.88515 8.07202 8.88515C8.18937 8.88515 8.30555 8.86192 8.41387 8.81679C8.52219 8.77166 8.6205 8.70554 8.70313 8.62222L14.2942 3.04V4.44444C14.2942 4.68019 14.3879 4.90628 14.5546 5.07298C14.7213 5.23968 14.9474 5.33333 15.1831 5.33333C15.4189 5.33333 15.645 5.23968 15.8117 5.07298C15.9784 4.90628 16.072 4.68019 16.072 4.44444V0.888889C16.072 0.653141 15.9784 0.427049 15.8117 0.26035C15.645 0.0936505 15.4189 0 15.1831 0H11.6276C11.3918 0 11.1657 0.0936505 10.999 0.26035C10.8323 0.427049 10.7387 0.653141 10.7387 0.888889C10.7387 1.12464 10.8323 1.35073 10.999 1.51743C11.1657 1.68413 11.3918 1.77778 11.6276 1.77778Z",
  fill: "url(#paint1_linear_1972_20961)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1972_20961",
  x1: 15.8964,
  y1: 15.7714,
  x2: 15.8964,
  y2: 0.121356,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7F8FA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1972_20961",
  x1: 15.9748,
  y1: 8.75821,
  x2: 15.9748,
  y2: 0.0673915,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7F8FA"
})));

function SvgExternalLinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkIcon);
export default __webpack_public_path__ + "static/media/external_link_icon.52d1fb00.svg";
export { ForwardRef as ReactComponent };